import React, { CSSProperties } from "react"


import styled from "styled-components";

export const Column = styled.div<{width?: string}>`
  display: flex;
  flex-direction: column;
  width: ${props => props.width || "100%"};
  overflow-y: auto;
`;

export const Row = styled.div<{width?: string, height?: string, align?: string, justify?: string }>`
  display:        flex;
  flex-direction: row;
  justify-content: ${props => props.justify || "flex-start" };
  align-items:     ${props => props.align || undefined};
  width:           ${props => props.width  || "100%"};
  height:          ${props => props.height || "100%"};
  min-height:      ${props => props.height || undefined};
`;

export const Spacer = styled.div<{width?: string, height?: string}>`
  display: flex;
  width:  ${props => props.width  || "100%"};
  height: ${props => props.height || "100%"};
`;